import { createRouter as createTanStackRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

export function createRouter() {
  return createTanStackRouter({
    routeTree,
    defaultPreload: 'intent',
    defaultErrorComponent: ({ error }) => {
      console.error('Router error component:', error)
      return (
        <div style={{ padding: '2rem', fontFamily: 'monospace' }}>
          <h2>Application Error</h2>
          <p style={{ color: 'red' }}>{error?.message || 'Unknown error occurred'}</p>
          <details>
            <summary>Stack trace</summary>
            <pre style={{ fontSize: '0.8rem' }}>{error?.stack}</pre>
          </details>
        </div>
      )
    },
  })
}

export const router = createRouter()

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}